import React, { useMemo } from 'react';
import styled, { keyframes } from 'styled-components';

const fall = keyframes`
  0%   { transform: translateY(-15vh) rotate(0deg); }
  100% { transform: translateY(115vh) rotate(360deg); }
`;

const Container = styled.div`
  position: fixed;
  inset: 0;
  pointer-events: none;
  overflow: hidden;
  z-index: 0;
`;

const Card = styled.img<{ left: number; size: number; duration: number; delay: number; opacity: number }>`
  position: absolute;
  left: ${p => p.left}vw;
  top: 0;
  width: ${p => p.size}px;
  height: ${p => p.size}px;
  opacity: ${p => p.opacity};
  animation: ${fall} ${p => p.duration}s linear infinite;
  animation-delay: ${p => -p.delay}s;
  will-change: transform;
  user-select: none;
  pointer-events: none;
`;

const COUNT = 16;

interface CardData {
  key: number;
  left: number;
  size: number;
  duration: number;
  delay: number;
  opacity: number;
}

export const FallingCards: React.FC = () => {
  const cards = useMemo<CardData[]>(() => {
    return Array.from({ length: COUNT }).map((_, i) => ({
      key: i,
      left: Math.random() * 100,
      size: 56 + Math.random() * 88,
      duration: 22 + Math.random() * 28,
      delay: Math.random() * 40,
      opacity: 0.05 + Math.random() * 0.05,
    }));
  }, []);

  return (
    <Container aria-hidden="true">
      {cards.map(c => (
        <Card
          key={c.key}
          src="/favicon.svg"
          alt=""
          left={c.left}
          size={c.size}
          duration={c.duration}
          delay={c.delay}
          opacity={c.opacity}
        />
      ))}
    </Container>
  );
};
